import { Grid, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';

// our Component
import FADashboardHeading from 'components/FADashboard/heading/FADashboardHeading';
import HighlightCardsSection from 'components/FADashboard/HighlightCards/HighlightCardsSection';
import FaPaginatedSummaryTable from 'components/Table/FADashboard/FADashboardPaginationTable';
import TableHeadingAndSearch from 'components/FADashboard/TableHeadingAndSearch';

// our Hooks
import useGetFaPaginatedSummary from 'hooks/advisorDashboard/useGetFaPaginatedSummary';

// our Atoms
import searchQueryAtom from 'state/atoms/paginationSearchAtom';

function FADashboardPage() {
	const [page, setPage] = useState(0);
	const [searchQuery, setSearchQuery] = useAtom(searchQueryAtom);

	const { data, isLoading, isFetching, isSuccess, error, refetch } =
		useGetFaPaginatedSummary(page, searchQuery);

	// When the search query changes, refetch the data and reset the page to 0
	useEffect(() => {
		if (searchQuery !== null) {
			refetch();
			setPage(0);
		}
	}, [searchQuery]);

	useEffect(
		() => () => {
			setSearchQuery('');
		},
		[]
	);

	if (error) {
		return (
			<>
				<Helmet>
					<title>Financial advisor dashboard</title>
				</Helmet>
				<Typography variant="h5" sx={{ marginTop: 20 }}>
					There was an error fetching your information.
				</Typography>
				<Typography variant="h5" sx={{ marginTop: 2 }}>
					Please refresh the page, if issue persist please reach out
					to sora at contact@sorafinance.com
				</Typography>
			</>
		);
	}

	if (isLoading) {
		return (
			<Grid container sx={{ alignItems: 'flex-start' }}>
				<FADashboardHeading />

				<HighlightCardsSection />

				<TableHeadingAndSearch
					disable={isLoading}
					deBounceCallBack={setSearchQuery}
					tableHeading="Clients"
					isPaginationLoading={isLoading}
				/>

				<Grid container item xs={12} sx={{ paddingRight: 4 }}>
					<FaPaginatedSummaryTable
						liabilities={data?.summaryLiability ?? []}
						page={page}
						setPage={(newPage) => {
							setPage(newPage);
						}}
						totalClient={data?.totalClient ?? 0}
						isFetching={isLoading || isFetching}
					/>
				</Grid>
			</Grid>
		);
	}

	if (isSuccess) {
		const { totalClient, summaryLiability } = data;

		return (
			<>
				<FADashboardHeading />

				<HighlightCardsSection />

				<TableHeadingAndSearch
					disable={totalClient < 1}
					deBounceCallBack={setSearchQuery}
					tableHeading="Clients"
				/>

				<Grid container item xs={12} sx={{ paddingRight: 4 }}>
					<FaPaginatedSummaryTable
						liabilities={summaryLiability}
						page={page}
						setPage={(newPage) => {
							setPage(newPage);
						}}
						totalClient={totalClient}
						isFetching={isLoading || isFetching}
					/>
				</Grid>
			</>
		);
	}
}

export default FADashboardPage;
